import { config } from 'affiny-core/env';
import { DEFAULT_LANGUAGE } from 'affiny-core/translations/constants';
import { i18n as i18nUI } from 'affiny-ui/src';
import dayjs from 'dayjs';
import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

const locales = {
  de: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/de'),
  en: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/en'),
  fr: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/fr'),
  it: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/it'),
  es: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/es'),
  pt: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/pt'),
  nl: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/nl'),
  da: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/da'),
  nb: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/nb'),
  sv: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/sv'),
  fi: () =>
    import(/* webpackChunkName: 'LocalesDesktopDayJs' */ 'dayjs/locale/fi'),
};

function loadLocale(language: string) {
  locales[language]().then(() => dayjs.locale(language));
}

const resources = {};

resources[config.env.locale] = {};
import(
  /* webpackChunkName: 'LocalesDesktop' */ 'affiny-locales/desktop/' +
    config.env.locale +
    '.json'
).then(translationsValue => {
  resources[config.env.locale]['translation'] = translationsValue;
});

i18n
  .use(initReactI18next)
  .use(new ICU())
  .init(
    {
      lng: config.env.locale,
      debug: process.env.NODE_ENV === 'development',
      fallbackLng: DEFAULT_LANGUAGE,
      resources: resources,
    },
    () => {
      import(
        /* webpackChunkName: 'LocalesUI' */ 'affiny-locales/ui/' +
          config.env.locale +
          '.json'
      ).then(translationsValue => {
        i18nUI.addResourceBundle(
          config.env.locale,
          'translation',
          translationsValue
        );
        i18nUI.changeLanguage(config.env.locale);
      });

      // Load dayjs locales
      loadLocale(config.env.locale);
    }
  );

export default i18n;
